import {collapsibleClick} from '../events'
import withSnowplowLifecycle from './withSnowplowLifecycle'

const withCollapsibleEvent = (WrappedComponent, options = null) => withSnowplowLifecycle(WrappedComponent, collapsibleClick, options)

export default withCollapsibleEvent
